module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": '== 品牌 ==',
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brand),
      callback: function($$v) {
        _vm.brand = $$v
      },
      expression: "brand"
    }
  })], 1), _vm._v(" "), _c('nd-trade-apply-store-multi-select-listbox', {
    attrs: {
      "brandId": _vm.brandId,
      "getDataH": _vm.getDataH,
      "status": _vm.status,
      "storeId": _vm.storeId,
      "tradeType": _vm.tradeType
    },
    on: {
      "update:choose": _vm.updateChoose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-1 font-size-subtitle-2 text-right",
    domProps: {
      "textContent": _vm._s(("已選 " + (_vm.chose.length) + " 擇"))
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-3 font-size-subtitle-1"
  }, [_c('span', [_vm._v("請選取欲申請的品牌（僅會顯示尚未產出網址的門市）。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc92084"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/nd-trade-apply-store.vue
// module id = 2411
// module chunks = 1